import React from 'react';
import globalStyles from '../globals.module.css';

/**
 * PageView Component - Uniform page structure wrapper
 * 
 * Provides a consistent structure for all page views:
 * - Container (full width with padding)
 * - Title (full width, left-aligned)
 * - Header (optional, full width, left-aligned) - shown if header prop provided
 * - Content (800px max-width, centered)
 * 
 * Type is implicit based on whether header prop is provided:
 * - Has header → 'feed' type (title + header + content)
 * - No header → 'simple' type (title + content)
 * 
 * @param {string} title - Page title text
 * @param {ReactNode} header - Optional header section (filters, controls, etc.)
 * @param {ReactNode} children - Main content to display
 * @param {string} containerClassName - Additional CSS classes for container
 * @param {string} headerClassName - Additional CSS classes for header
 * @param {string} contentClassName - Additional CSS classes for content wrapper
 */
const PageView = ({ 
    title,
    header,
    children,
    containerClassName = '',
    headerClassName = '',
    contentClassName = ''
}) => {
    const hasHeader = !!header;
    
    return (
        <div className={`${globalStyles.pageContainer} ${containerClassName}`}>
            {title && (
                <div className={globalStyles.viewTitle}>
                    <h2>{title}</h2>
                </div>
            )}
            
            {hasHeader && (
                <div className={`${globalStyles.pageHeader} ${headerClassName}`}>
                    {header}
                </div>
            )}
            
            <div className={`${globalStyles.pageContent} ${contentClassName}`}>
                {children}
            </div>
        </div>
    );
};

export default PageView;
